module.exports = __webpack_public_path__ + "img/news12.ffc18247.png";